import React from 'react';
import './Key Features.css';

const KeyFeatures = () => {
  return (
    <section className="key-features-section">
      {/* Background Video */}
      <video
        className="key-features-video"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="./animation2.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Section Content */}
      <div className="section-header">
        <h2>Key Features</h2>
      </div>
      <div className="key-features-content">
        <div className="feature-card">
          <h3>Insights Platform</h3>
          <p>Engage in real-time Sessions with Experts</p>
        </div>
        <div className="feature-card">
          <h3>Advanced Search</h3>
          <p>Find relevant Experts and content with powerful search</p>
        </div>
        <div className="feature-card obka">
          <h3>OBKA</h3>
          <p>Find intelligent answers to difficult questions using our RAG-based Gen-AI system OBKA</p>
        </div>
        <div className="feature-card">
          <h3>Networking</h3>
          <p>Connect and collaborate with other vetted professionals on the platform</p>
        </div>
        <div className="feature-card">
          <h3>Exclusivity & Network Protection</h3>
          <p>Ensure a clean and high-quality network, facilitating safe space for sensitive discussions</p>
        </div>
        <div className="feature-card">
          <h3>Royalties</h3>
          <p>Earn money on every bit of knowledge contribution, perpetually</p>
        </div>
      </div>
    </section>
  );
};

export default KeyFeatures;
